function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9 36V33.3333C30.9 31.9188 30.3311 30.5623 29.3184 29.5621C28.3057 28.5619 26.9322 28 25.5 28H17.4C15.9678 28 14.5943 28.5619 13.5816 29.5621C12.5689 30.5623 12 31.9188 12 33.3333V36",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.45 22.6667C24.4323 22.6667 26.85 20.2789 26.85 17.3333C26.85 14.3878 24.4323 12 21.45 12C18.4677 12 16.05 14.3878 16.05 17.3333C16.05 20.2789 18.4677 22.6667 21.45 22.6667Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39 35.9998V33.3331C38.9991 32.1514 38.6009 31.0035 37.8678 30.0695C37.1348 29.1356 36.1085 28.4685 34.95 28.1731",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9 12.1731C32.0616 12.4668 33.0911 13.134 33.8263 14.0695C34.5615 15.005 34.9606 16.1555 34.9606 17.3398C34.9606 18.524 34.5615 19.6745 33.8263 20.61C33.0911 21.5455 32.0616 22.2127 30.9 22.5064",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 24.5,
  stroke: "black",
  strokeWidth: 2
});

var SvgFeatureIcon7 = function SvgFeatureIcon7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeatureIcon7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/featureIcon7.7aa875f4.svg";
export { ForwardRef as ReactComponent };